import React from 'react'

// import ScrollHide from '../Layouts/ScrollHide'
const About = () => {
    return (
        <>
            <section className="about" id='about'>
                <div className="about__aboutme-text">About Me</div>
                <div className="reveal-holder" data-aos="reveal-item">
                    <div className="reveal-block left" data-aos="reveal-left"></div>
                    <div className="about__main">
                        <div className="about-body-font">
                            As a passionate Software Engineer, I am driven to play a key role in all stages of software development, from initial planning to final solution delivery in the digital world.
                        </div>
                        <br />
                        <div className="about-body-font">
                            My main objective is to enhance user experiences by leveraging my expertise in software development.
                        </div>
                    </div>
                </div>
                
            </section>
        </>

    )
}

export default About
